import React from "react";

export default function ArrowsSort() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 6.5L16.5 17.5M16.5 17.5L13 14M16.5 17.5L20 14M7.5 17.5L7.5 6.5M7.5 6.5L4 10M7.5 6.5L11 10"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
